(function () {
  class SymbolOverlayDisplay extends PIXI.Container {
    constructor() {
      super();
    }

    initialise() {
      this._callback = undefined;
      this._panels = [];

      messageBus.subscribe('spinner:GameConfigEvent', () => {
        this.onLayoutComplete();
      });
    }

    doEndDelay(time) {
      timerManager.addTimeout(time, () => {
        this._callback();
      });
    }

    addBonusOverlays(data) {
      for (let i = 0; i < data.length; i++) {
        let position = data[i].cell;
        this._panels[position.reel][position.row].bonus.visible = true;
        this._panels[position.reel][position.row].bonus.data = data[i];
      }
    }

    recenterOverlays() {
      const containerPos = this.position;
      const containerScale = this.scale;

      for (let reel = 0; reel < this._panels.length; reel++) {
        for (let row = 0; row < this._panels[reel].length; row++) {
          const bonus = this._panels[reel][row].bonus;

          const pos = helpers.getSymbolPos(reel, row, true);

          bonus.position.x = (pos.x - containerPos.x) / containerScale.x;
          bonus.position.y = (pos.y - containerPos.y) / containerScale.y;
          bonus._movie.position.x = (pos.x - containerPos.x) / containerScale.x;
          bonus._movie.position.y = (pos.y - containerPos.y) / containerScale.y;
        }
      }
    }

    hideAllBonusOverlays() {
      for (let reel = 0; reel < this._panels.length; reel++) {
        for (let row = 0; row < this._panels[reel].length; row++) {
          const bonus = this._panels[reel][row].bonus;
          // Kill any running GSAP animations on the bonus symbol scale
          gsap.killTweensOf(bonus.scale);
          // Reset scale to default
          bonus.scale.set(1, 1);
          // Hide visibility and movie
          bonus.visible = false;
          bonus.hideMovie();
        }
      }
    }

    dimAllSymbols(showDim, duration) {
      for (let reel = 0; reel < this._panels.length; reel++) {
        for (let row = 0; row < this._panels[reel].length; row++) {
          this.dimSymbol(reel, row, showDim, duration);
        }
      }
    }

    dimSymbols(symbols, showDim, duration) {
      for (let i = 0; i < symbols.length; i++) {
        let reel = symbols[i].reel;
        let row = symbols[i].row;

        this.dimSymbol(reel, row, showDim, duration);
      }
    }

    dimSymbol(reel, row, showDim, duration) {
      if (reel < 0 || reel > 5 || row < 0 || row > 3) {
        return;
      }

      let targetTint = showDim ? 0x777777 : 0xffffff;
      const symbol = this._panels[reel][row].bonus;
      if (duration) {
        gsap.to(symbol, {
          duration,
          pixi: { tint: targetTint },
        });
      } else {
        symbol.tint = targetTint;
      }
    }

    onLayoutComplete() {
      const overReelsLayer = resourceManager.get('symbolOverlayDisplay:symbolOverlayDisplayContainer');

      for (let reel = 0; reel < 5; reel++) {
        const panelRow = [];
        for (let row = 0; row < 3; row++) {
          const panel = this.createBonusPanel(reel, row, overReelsLayer);
          panelRow.push(panel);
        }
        this._panels.push(panelRow);
      }
    }

    createBonusPanel(reel, row, container) {
      const pos = helpers.getSymbolPos(reel, row, true);
      const bonusId = `bonus_${reel}_${row}`;
      const movieId = `bonusMovie_${reel}_${row}`;

      const containerPos = this.position;
      const containerScale = this.scale;
      const relativeX = (pos.x - containerPos.x) / containerScale.x;
      const relativeY = (pos.y - containerPos.y) / containerScale.y;

      // Create bonus sprite
      const bonus = resourceManager.createObject('sprite', bonusId, container.name, {
        fileName: 'Symbols/Bonus/Oversized/freespins_00.png',
        anchor: 0.5,
        x: relativeX,
        y: relativeY,
      });
      bonus.visible = false;

      // Create and attach movie
      bonus._movie = resourceManager.createObject('movie', movieId, container.name, {
        definition: 'Bonus',
        anchor: 0.5,
        x: relativeX,
        y: relativeY,
        loop: false,
      });
      bonus._movie.visible = false;
      bonus._movie.gotoAndStop(0);

      bonus.playMovie = (onComplete) => {
        bonus._movie.visible = true;
        bonus._movie.onComplete = onComplete;
        bonus._movie.gotoAndPlay(0);
      };

      bonus.hideMovie = () => {
        if (bonus._movie) {
          bonus._movie.visible = false;
          bonus._movie.gotoAndStop(0);
        }
      };

      return { bonus };
    }
  }

  create = function (json) {
    return new SymbolOverlayDisplay();
  };

  getFilesRequired = function (json) {
    return [];
  };

  resourceManager.registerObjectType('symbolOverlayDisplay', create, initialise, getFilesRequired);
})();
